/** Categorical slot colour, by the series' position in its payload. */
export const seriesColor = (i) => `var(--series-${(i % 8) + 1})`;

/** Round a maximum up to a 1/2/2.5/5 × 10^n axis bound. */
export function niceMax(max) {
  if (!Number.isFinite(max) || max <= 0) return 1;
  const exp = Math.pow(10, Math.floor(Math.log10(max)));
  const f = max / exp;
  const nice = f <= 1 ? 1 : f <= 2 ? 2 : f <= 2.5 ? 2.5 : f <= 5 ? 5 : 10;
  return nice * exp;
}
